import { Component, Input, OnInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../app.service';
import { APP_Constants } from '../app.constant';
import { ActivatedRoute, Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalService } from 'src/app/common/modal/modal.service';
import { GenericModalV2Component } from 'src/app/shared/common/generic-modal-v2/generic-modal-v2.component';
import { Constant } from '../shared/constants/constants'
import { ModalConfigData } from '../common/modalconfig/modalconfig';
import { environment } from 'src/environments/environment';
import { MatSelect,MatSelectChange} from '@angular/material/select'
import FileSaver from 'file-saver';
import { Modal } from '../common/modal/modal';

@Component({
    selector: 'app-app-switch-user',
    templateUrl: './app-switch-user.component.html',
    styleUrls: ['./app-switch-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AppSwitchUserComponent implements OnInit {
  fileData: any;
  userRole: string;
  customerCode: string;
  customerChanged: boolean;
  customerNewList: any;
  searchTxt: any;
  preferredUOM;
  userAcessDataRest;
  parameterValue;
  constructor(private appService: AppService, private router: Router, public translate: TranslateService, private matDialog: MatDialog, private modalService: ModalService,private activeRoute: ActivatedRoute) { }

  selectedCustomer;
  customerList;
  languageList = [
  {
    "key": "EN",
    "label": "English",
    "flag": "en_flag.png"
  },
  {
      "key": "ES",
      "label": "Spanish",
      "flag": "es_flag.png"
  }];
  selectedLang = 'EN';
  selectedLangString =  {"key": "EN", "label": "English", "flag": "en_flag.png"};
  isMultiLangAvailable = false;
  isContactAvailable = false;
  isCustomerDropdownThemeAvailable = false;
  isMultipleCustomerAvailable = false;
  isActiveProject: boolean;
  defaultLang = 'EN';
  defaultColor='#191919';
  confirmLanguageChangeDlg: MatDialogRef<GenericModalV2Component>;
  isMultiLanguageAvailable;
  textcolor;
  downloadUrl;
  menuPages;
  isCustomerDropdownOpen = false;
  isLanguageDropdownOpen = false;
  isHelpMenuOpen = false;
  ngOnInit() {
    this.selectedCustomer = localStorage.getItem('customerCode');
    this.textcolor = localStorage.getItem('customerDropdownColor');
    this.isMultiLanguageAvailable = localStorage.getItem('isMultiLangAvailable')
    if(this.textcolor == "undefined")
    {
      this.textcolor = this.defaultColor;
    }
    if( this.isMultiLanguageAvailable == 'TRUE'){
      this.isMultiLangAvailable = true;
    }
   
    let list = localStorage.getItem('customerList');
    if (list) {
      this.customerList = JSON.parse(list);
      this.initCustomerDropdown(this.customerList,this.selectedCustomer);
    }
    this.initMultiLanguage();
    this.initContactPageDropdown();
    this.menuPages = localStorage.getItem("menuPages")
  }

  modelChangeFn(value) {
    this.customerNewList = this.customerList.filter(
     item => {
      return item.customerName.toString().toLowerCase().indexOf(value.toLowerCase()) > -1
    }
    ); 
  }
  
  // initMultiLanguage(){
  //   if(localStorage.getItem('customerCode') == 'MAR'){
  //     this.isMultiLangAvailable = true;
  //   }
  //   let browserLang = this.translate.getBrowserLang().toUpperCase();
  //   this.selectedLang = (this.languageList.indexOf(browserLang) > -1) ? browserLang : this.selectedLang;
  //   this.translate.addLangs(this.languageList);
  //   this.translate.use(this.selectedLang);
  // }

  initCustomerDropdown(data,selectedCustomer){
    this.isCustomerDropdownThemeAvailable = this.appService.checkCustomerDropdown();
  }

  redirectToContact() {
    this.router.navigateByUrl('/contact');
    this.isActiveProject= true;
  }

  initMultiLanguage(){
    let languageKey = [];
    this.isMultiLangAvailable = this.appService.checkMultiLangSupport();
    this.isMultipleCustomerAvailable = this.appService.checkMultipleCustomer();

    let browserLang = (sessionStorage.getItem('selected_lang_key')) ? sessionStorage.getItem('selected_lang_key') : this.translate.getBrowserLang().toUpperCase();
    
    for (let i = 0; i < this.languageList.length; i++) {
      this.selectedLang = (this.languageList[i].key == browserLang) ? (this.isMultiLangAvailable ? browserLang : this.defaultLang ) : this.selectedLang;
      languageKey.push(this.languageList[i].key);
    }
    
    let lang_key = (sessionStorage.getItem('selected_lang_key')) ? sessionStorage.getItem('selected_lang_key') : 'EN';
    let lang_label = (sessionStorage.getItem('selected_lang_label')) ? sessionStorage.getItem('selected_lang_label') : 'English';
    let lang_flag = (sessionStorage.getItem('selected_lang_flag')) ? sessionStorage.getItem('selected_lang_flag') : 'en_flag.png';

    this.selectedLangString =  {"key": lang_key, "label": lang_label, "flag": lang_flag};

    this.translate.addLangs(languageKey);
    this.translate.use(this.selectedLang);
  }

  changeLanguage(langSelect, oldKey, oldLabel){
    this.confirmLanguageChange(langSelect, oldKey, oldLabel);
  }

  confirmLanguageChange(langSelect, oldKey, oldLabel) {
    const subject = new Subject<boolean>();
    
    let config = {
      actions: true, type: 'confirm', name: 'Language Change', title: 'Confirm Language Change', 
      description: ModalConfigData.LANGUAGECHANGE_POPUP.DESCRIPTION,
      actionButtonText:ModalConfigData.BUTTONS.BUTTONCONFIRM,
      showCancel: true,
      imgIcon: '../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1350,24,24))'
    }

    let modalConfig: MatDialogConfig<any> = new ModalConfig(config);
    this.confirmLanguageChangeDlg = this.matDialog.open(GenericModalV2Component, modalConfig);

    this.confirmLanguageChangeDlg.componentInstance.subject = subject;

    this.confirmLanguageChangeDlg.afterClosed()
      .subscribe(async response => {
        if (response) {
          let langLower = langSelect.value.toLowerCase();
          let flag_icon = langLower+'_flag.png';

          sessionStorage.setItem('selected_lang_key', langSelect.value);
          sessionStorage.setItem('selected_lang_label', langSelect.source.triggerValue.replace('check',''));
          sessionStorage.setItem('selected_lang_flag', flag_icon);

          window.location.reload();

        } else {
          let langLower = oldKey.toLowerCase();
          let flag_icon = langLower+'_flag.png';

          sessionStorage.setItem('selected_lang_key', oldKey);
          sessionStorage.setItem('selected_lang_label', oldLabel);
          sessionStorage.setItem('selected_lang_flag', flag_icon);

          this.initMultiLanguage();
        }
      });
    
  }

  changeCustomer(e) {
    // fetch url data from template
    localStorage.removeItem("dynamicsortdata");
    this.customerChanged = true
    if(!e || e.value == undefined){
      if(this.customerNewList== undefined||this.customerNewList.length == 0){
        this.selectedCustomer = localStorage.getItem('customerCode');
        e.value = localStorage.getItem('customerCode');
      }
     
    }
  
    this.appService.makeHttpGetRequest(APP_Constants.SWITCH_CUSTOMER + localStorage.getItem('userName') +
      '&customerCode=' + e.value).subscribe(response => {
        if (response['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          let userData = response['userData'];
          console.log(userData);
          localStorage.setItem('userData', JSON.stringify(userData));
          localStorage.setItem('menuPages', JSON.stringify(userData.menuPages));
          localStorage.setItem('userName', userData.userName);
          localStorage.setItem('firstName', userData.firstName);
          localStorage.setItem('lastName', userData.lastName);
          localStorage.setItem('customerName', userData.customerName);
          localStorage.setItem('lastLogin', userData.lastLogin);
          localStorage.setItem('defaultHomepage', userData.defaultMenu);
          localStorage.setItem('superuser', userData.isSuperUser);
          localStorage.setItem('superuserreadonly', userData.isReadOnlySuperUser);
          localStorage.setItem('readonlyeditownaccess', userData.isEditOwnAccess);
          localStorage.setItem('alwaysUseDHLTheme', userData.alwaysUseDHLTheme);

          localStorage.setItem('customerDropdownColor', userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR);
          localStorage.setItem('isMultiLangAvailable', userData.customerCusomizations.ISMULTILANGUAGE);

          localStorage.removeItem("selectedLocation");
          this.isMultiLanguageAvailable = localStorage.getItem('isMultiLangAvailable');
          if(userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR){
            this.textcolor = userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR;
          }
          if( this.isMultiLanguageAvailable == 'TRUE'){
            this.isMultiLangAvailable = true;
          }else{
            this.isMultiLangAvailable = false;
          }
          
          let customerCode = '';
          if (userData.preferedCustomerCode) {
            customerCode = userData.preferedCustomerCode;
          } else {
            customerCode = userData.defaultCustomerCode;
          }
          localStorage.setItem('customerCode', customerCode);

          let userRole = '';
          let secondaryUserRoles = '';
          userData.userCustomerSubscriptionList.forEach(element => {
            if (element.customerCode === customerCode) {
              userRole = element.userRole;
              secondaryUserRoles = element.secondaryUserRoles;
              this.preferredUOM = element.preferredUOM;
              this.userAcessDataRest = element.customerSubscriptionDataRestriction;
              this.parameterValue = element.parameterValue;
            }
          });

          localStorage.setItem('preferredUOM',this.preferredUOM);
          localStorage.setItem('userRole', userRole);
          localStorage.setItem('secondaryUserRoles', secondaryUserRoles);
          localStorage.setItem('customerList', JSON.stringify(userData.userCustomerSubscriptionList));
          localStorage.setItem('userAcessDataRest', JSON.stringify(this.userAcessDataRest));
          localStorage.setItem('isMultiLangSupport', this.appService.checkMultiLangSupport().toString());
          localStorage.setItem('parameterValue', JSON.stringify(this.parameterValue));
          localStorage.removeItem("selectedLocation");

          let imgResp = userData.customerCusomizations,
          logoD = imgResp && imgResp.IMAGE_LOGOD ? imgResp.IMAGE_LOGOD : "",
          logoM = imgResp && imgResp.IMAGE_LOGOM ? imgResp.IMAGE_LOGOM : "",
          logoS = imgResp && imgResp.IMAGE_LOGOS ? imgResp.IMAGE_LOGOS : "";
          localStorage.setItem('logoD', logoD);
          localStorage.setItem('logoM', logoM);
          localStorage.setItem('logoS', logoS); 
          
          if(userData.isSuperUser)
            userData.contentPages.push('SUPERUSER');
          if(userData.isReadOnlySuperUser)
            userData.contentPages.push('SUPERUSERREADONLY');
          localStorage.setItem('portalSideMenu', JSON.stringify(userData.contentPages));
          this.appService._navigationSubject.next(userData.contentPages);
          this.initMultiLanguage();
          this.initContactPageDropdown();
          this.initCustomerDropdown(this.customerList,this.selectedCustomer);
          if (userData.defaultMenu) {
            if (window.location.pathname == userData.defaultMenu)
              window.location.reload();
            else {
              if(environment.showDashboard){
                this.router.navigateByUrl('/dashboard');
              } else{
                this.router.navigateByUrl(userData.defaultMenu);
              }
            }              
          } else {
            // navigate to profile
            this.router.navigateByUrl('/profile');
          }
        }
      }, err => {
        console.log(err);
      });
  }

  initContactPageDropdown(){
    this.isContactAvailable = this.appService.checkContactPage();
  }

  downloadFile() {
    this.userRole = localStorage.getItem('userRole');
    this.customerCode = localStorage.getItem("customerCode")
    let API = APP_Constants.TRAINING_DOC_DOWNLOAD+"?customerCode="+this.customerCode+"&userId="+localStorage.getItem('userName')+"&documentType=TraningDocument&role="+this.userRole+'&action=SEARCH_ORDER';
    this.appService.makeHttpGetRequest(API).subscribe((res: any) => {
      let fileName = res?.FileName;
      let base64File = 'data:' + res['Content-Type'] + ';base64,' + res.Data;
      FileSaver.saveAs(base64File, fileName);
    }, async (err) => {
      let modal = new Modal({
        action: false, name: 'download', title: 'Download File', actionButtonText: '',description: 'There was an error in downloading the file. Please try again later.'
      });
      this.modalService.createModalBox(modal, err.status);
    })
  }

  callSwitchUser(){
    this.appService.makeHttpGetRequest(APP_Constants.SWITCH_CUSTOMER + localStorage.getItem('userName') +
    '&customerCode=' + this.selectedCustomer).subscribe(response => {
      if (response['message'].statusCode === APP_Constants.SUCCESS_CODE) {
        let userData = response['userData'];
        localStorage.setItem('userData', JSON.stringify(userData));
        localStorage.setItem('menuPages', JSON.stringify(userData.menuPages));
        localStorage.setItem('userName', userData.userName);
        localStorage.setItem('firstName', userData.firstName);
        localStorage.setItem('lastName', userData.lastName);
        localStorage.setItem('customerName', userData.customerName);
        localStorage.setItem('lastLogin', userData.lastLogin);
        localStorage.setItem('defaultHomepage', userData.defaultMenu);
        localStorage.setItem('superuser', userData.isSuperUser);
        localStorage.setItem('alwaysUseDHLTheme', userData.alwaysUseDHLTheme);
        localStorage.setItem('customerDropdownColor', userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR);
        localStorage.setItem('isMultiLangAvailable', userData.customerCusomizations.ISMULTILANGUAGE)

        let imgResp = userData.customerCusomizations,
        logoD = imgResp && imgResp.IMAGE_LOGOD ? imgResp.IMAGE_LOGOD : "",
        logoM = imgResp && imgResp.IMAGE_LOGOM ? imgResp.IMAGE_LOGOM : "",
        logoS = imgResp && imgResp.IMAGE_LOGOS ? imgResp.IMAGE_LOGOS : "";
        localStorage.setItem('logoD', logoD);
        localStorage.setItem('logoM', logoM);
        localStorage.setItem('logoS', logoS); 

        this.isMultiLanguageAvailable = localStorage.getItem('isMultiLangAvailable');
        if(userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR){
          this.textcolor = userData.customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR;
        }
        if( this.isMultiLanguageAvailable == 'TRUE'){
          this.isMultiLangAvailable = true;
        }else{
          this.isMultiLangAvailable = false;
        }
        let customerCode = '';
        if (userData.preferedCustomerCode) {
          customerCode = userData.preferedCustomerCode;
        } else {
          customerCode = userData.defaultCustomerCode;
        }
        localStorage.setItem('customerCode', customerCode); 
        let userRole = '';
        let secondaryUserRoles = '';
        let customerColorCode = '';
        userData.userCustomerSubscriptionList.forEach(element => {
          if (element.customerCode === customerCode) {
            userRole = element.userRole;
            secondaryUserRoles = element.secondaryUserRoles;
            customerColorCode = element.customerDropdownColor;
            this.preferredUOM = element.preferredUOM;
            this.userAcessDataRest = element.customerSubscriptionDataRestriction;
            this.parameterValue = element.parameterValue;
          }
        });    
        localStorage.setItem('preferredUOM',this.preferredUOM);
        localStorage.setItem('userRole', userRole);
        localStorage.setItem('secondaryUserRoles', secondaryUserRoles);
        localStorage.setItem('customerDropdownColor', customerColorCode);
        // localStorage.setItem('customerList', JSON.stringify(userData.userCustomerSubscriptionList));
        localStorage.setItem('isMultiLangSupport', this.appService.checkMultiLangSupport().toString());   
        localStorage.setItem('userAcessDataRest', JSON.stringify(this.userAcessDataRest));
        localStorage.setItem('parameterValue', JSON.stringify(this.parameterValue));
        if(userData.isSuperUser)
          userData.contentPages.push('SUPERUSER');
        localStorage.setItem('portalSideMenu', JSON.stringify(userData.contentPages));
        this.appService._navigationSubject.next(userData.contentPages);
        this.initMultiLanguage();
      //  this.initCustomerDropdown(customerListDummy,this.selectedCustomer);
        if (userData.defaultMenu) {
          if (window.location.pathname == userData.defaultMenu)
            window.location.reload();
          else {
            if(environment.showDashboard){
              this.router.navigateByUrl('/dashboard');
            } else{
              this.router.navigateByUrl(userData.defaultMenu);
            }
          }              
        } else {
          // navigate to profile
          this.router.navigateByUrl('/profile');
        }
        localStorage.removeItem("selectedLocation");
      }
    }, err => {
      console.log(err);
    });
    
  }
  onCloseMethod(e){
    console.log('closed')
    console.log(e);
    if(e==undefined){
      console.log(" ");
    }
    if(this.searchTxt && this.customerNewList.length == 0){
      console.log("...")
      this.selectedCustomer = localStorage.getItem('customerCode');
      this.callSwitchUser();
    }

    if(this.searchTxt && this.customerNewList.length != 0 && this.customerChanged == false){
    this.selectedCustomer = localStorage.getItem('customerCode');
      this.callSwitchUser(); 
    }
  }

  toggleCustomerDropdown() {
    if (this.isHelpMenuOpen) {
      this.isHelpMenuOpen = false;
      return;
    }
    this.isCustomerDropdownOpen = !this.isCustomerDropdownOpen;
    if (this.isCustomerDropdownOpen) {
      this.scrollToSelectedCustomer();
      // Force mobile dropdown to be visible
      setTimeout(() => {
        const dropdown = document.querySelector('.custom-options') as HTMLElement;
        if (dropdown && window.innerWidth <= 450) {
          dropdown.style.display = 'block';
          dropdown.style.visibility = 'visible';
        }
      }, 10);
    }
  }

  selectCustomer(customerCode: string, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.selectedCustomer === customerCode) {
      this.isCustomerDropdownOpen = false;
      return;
    }
    this.selectedCustomer = customerCode;
    this.isCustomerDropdownOpen = false;
    this.changeCustomer({ value: customerCode });
  }

  getSelectedCustomerName(): string {
    if (!this.customerList || !this.selectedCustomer) return '';
    const customer = this.customerList.find(c => c.customerCode === this.selectedCustomer);
    return customer ? customer.customerName : '';
  }

  scrollToSelectedCustomer() {
    setTimeout(() => {
      const selectedElement = document.querySelector('.option.selected');
      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }, 50);
  }

  toggleLanguageDropdown() {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  selectLanguage(lang: any) {
    this.isLanguageDropdownOpen = false;
    const event = {
      value: lang.key,
      source: {
        triggerValue: lang.label
      }
    };
    this.changeLanguage(event, this.selectedLangString.key, this.selectedLangString.label);
  }

  toggleHelpMenu() {
    if (this.isCustomerDropdownOpen) {
      this.isCustomerDropdownOpen = false;
      return;
    }
    this.isHelpMenuOpen = !this.isHelpMenuOpen;
  }

  closeHelpMenu() {
    this.isHelpMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-select-container') && !target.closest('.help-menu-pane')) {
      this.isCustomerDropdownOpen = false;
      this.isLanguageDropdownOpen = false;
      this.isHelpMenuOpen = false;
    }
  }
}
